export default __webpack_public_path__ + "static/media/6.eb0278ab.jpg";